export default __webpack_public_path__ + "static/media/sponsorIcon.41cd9eca.png";